<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-company fade-in-animation">
    <div class="card area-to-overlay">
      <div class="card-content">

        <header>
          <h1>Cadastro da Empresa</h1>
          <p class="description">Informações gerais sobre a sua empresa</p>
        </header>

        <p *ngIf="error">{{error}}</p>

          <div *ngIf="!error && company">
            <div style="display: flex; align-items: flex-start;">
              <div style="width: 30%;">
                <div *ngIf="!error">
                <h2>Logo</h2>
                <div class="row">
                  <div class="col-xs-12 col-md-4">
                    <div class="item logo-box" *ngIf="!showImageDiv" (click)="crop.setImage()">
                      <i class="fa fa-image"></i>
                    </div>

                    <div class="item logo-box" *ngIf="showImageDiv">
                      <img [src]="getWebImageUrl(company.image_key)">
                    </div>

                    <image-cropper #crop (cropEvent)="getImage($event)" [imageHeight]="200"></image-cropper>

                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12" *ngIf="!company.image_key">
                    <a href="https://google.com/search?tbm=isch&q={{ company['name'] }}+logo" target="_blank">{{ 'REGISTRATION_COMPANY.LOGO.SEARCH_LOGO_IMAGE_LABEL' | translate }}</a>
                  </div>

                  <div class="col-xs-12" *ngIf="company.image_key && !isLoading">
                    <a (click)="clearImage()"> {{ 'REGISTRATION_COMPANY.LOGO.CLEAR_IMAGE' | translate }}</a>
                  </div>
                </div>
              </div>
              <div class="loading-overlay" *ngIf="isLoading">
                <div class="loader-wrp">
                  <div class="loader"><span></span><span></span><span></span></div>
                  <p> {{ 'LOADING' | translate }}</p>
                </div>
              </div>
            </div>
            <div style="margin: 20px 0 0 0; width: 100%;">
              <div class="responsive-columns">
                <div>
                  <label>
                    Nome da empresa*<br />
                    <input class="form-control" placeholder="Nome do Empresa" [(ngModel)]="company.name" />
                  </label>
                </div>
                <div class="cnpj">
                  <label>
                    CNPJ*<br />
                    <input name="" class="form-control" placeholder="" [ngModel]="company.cnpj"
                      [textMask]="{mask: cnpjMask}" readonly />
                  </label>
                </div>
              </div>
              <div class="responsive-columns">
                <div>
                  <label style="width: 50%;">
                    Site<br />
                    <input class="form-control" placeholder="Site da Empresa" [(ngModel)]="company.urls.url_website" />
                  </label>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="cost-center">
            <h1>Grupos (centro de custo/unidade)</h1>
            <p class="description">Adicione Grupos para visualizar relatórios segmentados e ter a possibilidade de faturar por grupo.</p>
            <table class="table table-striped table-borderless">
              <thead>
                <tr>
                  <th *ngFor="let header of headerList" scope="col">
                    {{header}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let unit of unitsList">
                  <td>{{unit.name}}</td>
                  <td>{{unit.cnpj | cnpj}}</td>
                  <td>{{unit.code}}</td>
                  <td>{{unit.address_types?.name}}</td>
                  <div class="action-options">
                    <td (click)="openModal(unit)">
                      <span class="fa fa-edit" tooltip="Editar" placement="bottom" show-delay="20"></span></td>
                    <td (click)="confirmModal(unit.id)">
                      <span class="fa fa-trash" tooltip="Excluir" placement="bottom" show-delay="20"></span></td>
                  </div>
                </tr>
                <tr *ngIf="!unitsList.length">
                  <p class="empty-msg">Nenhuma unidade cadastrada até o momento.</p>
                </tr>
              </tbody>
            </table>
            <div class="paginator" *ngIf="unitsList.length">
                <div class="row">
                  <div class="col-md-10 page-info">
                    <p>Página {{pagination.pageNumber}} de {{pagination.totalPages}}</p>
                  </div>
                  <div class="col-md-2 buttons">
                    <button mat-icon-button (click)="previousPage()">
                      <span class="fa fa-chevron-left"></span>
                    </button>
                    <button mat-icon-button (click)="nextPage()">
                      <span class="fa fa-chevron-right"></span>
                    </button>
                  </div>
                </div>
            </div>
            <p class="add-unit-text" (click)="openModal()">+ Adicionar unidade</p>
            <h1>Faturamento</h1>
            <div *ngIf="company" class="col-md-4 col-sm-12 padding-top select">
              <ss-multiselect-dropdown
                [options]="optionsUnit"
                [settings]="settingsSelectUnit"
                [(ngModel)]="company.revenues">
              </ss-multiselect-dropdown>
            </div>
            <p class="description select" *ngIf="company && company.revenues == 'holding'">
              O faturamento será realizado para o CNPJ<br><b>{{company.cnpj}}</b> cadastrado para sua empresa.</p>
            <p class="description select" *ngIf="company && company.revenues == 'group'">O faturamento será realizado para as
              unidades<br>adicionadas em grupos.</p>
          </div>
          <div class="responsive-columns">
            <div>
              <button *ngIf="!isLoading" (click)="updateCompany()" class="btn-orange">Salvar Alterações</button>
            </div>
          </div>
        </div>

        <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal #modalCostCenter [backdrop]="true" class="modal-unit">
    <modal-header>
      <h2>{{editMode? 'Editar' : 'Adicionar'}} Unidade</h2>
    </modal-header>
    <modal-content>
      <cost-center-form
        #costCenterForm
        (closeModal)="closeModal($event)">
      </cost-center-form>
    </modal-content>
  </modal>

  <modal #modalConfirmDelete [backdrop]="true" class="modal-confirm-remove">
    <modal-content>
      <h4 class="title">Deseja realmente excluir esta unidade?</h4>
      <div class="btn-row">
        <button (click)="closeModal('true')" class="btn-orange-contrast">Não</button>
        <button (click)="removeUnit()" class="btn-orange">Sim</button>
      </div>
    </modal-content>
  </modal>
